// Registro infortuni/incidenti HSE
import { useQuery } from '@tanstack/react-query'
import { Plus } from 'lucide-react'
import { PageHeader } from '../../components/layout/PageHeader'
import { Button } from '../../components/ui/Button'
import { Table } from '../../components/ui/Table'
import { Badge } from '../../components/ui/Badge'
import { formatDate } from '../../lib/utils'
import api from '../../lib/api'

interface Incident { id: string; date: string; type: string; severity: 'low' | 'medium' | 'high' | 'critical'; technicianName: string; description: string; resolved: boolean }

export function IncidentsPage() {
  const { data = [], isLoading } = useQuery({
    queryKey: ['hse', 'incidents'],
    queryFn: async () => {
      try {
        const res = await api.get<Incident[]>('/hse/incidents')
        return res.data ?? []
      } catch {
        // endpoint non ancora disponibile
        return [] as Incident[]
      }
    },
  })

  const columns = [
    { key: 'date', header: 'Data', cell: (i: Incident) => <span className="text-sm">{formatDate(i.date, 'dd/MM/yyyy')}</span>, className: 'w-28' },
    { key: 'type', header: 'Tipo', cell: (i: Incident) => <Badge variant="default">{i.type}</Badge>, className: 'w-28' },
    { key: 'technician', header: 'Tecnico', cell: (i: Incident) => <span>{i.technicianName}</span>, className: 'w-36' },
    { key: 'severity', header: 'Gravità', cell: (i: Incident) => (
      <Badge variant={i.severity === 'critical' || i.severity === 'high' ? 'danger' : i.severity === 'medium' ? 'warning' : 'default'}>
        {i.severity}
      </Badge>
    ), className: 'w-28' },
    { key: 'description', header: 'Descrizione', cell: (i: Incident) => <span className="text-sm text-[var(--fc-foreground-muted)] truncate max-w-xs">{i.description}</span> },
    { key: 'resolved', header: 'Stato', cell: (i: Incident) => <Badge variant={i.resolved ? 'success' : 'warning'}>{i.resolved ? 'Risolto' : 'Aperto'}</Badge>, className: 'w-24' },
  ]

  return (
    <div className="space-y-4">
      <PageHeader
        title="Registro infortuni"
        breadcrumb={[{ label: 'HSE', href: '/hse' }, { label: 'Infortuni' }]}
        actions={<Button leftIcon={<Plus className="h-4 w-4" />}>Nuovo incidente</Button>}
      />
      <Table
        data={data}
        columns={columns}
        keyExtractor={(i) => i.id}
        isLoading={isLoading}
        emptyMessage="Nessun incidente registrato"
      />
    </div>
  )
}
